import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { BehaviorSubject, Subject } from "rxjs";


type AlertData = {
  summary: string;
  detail: string;
  sticky: boolean;
  key: string;

}
@Injectable({
  providedIn: "root",
})
export class AlertsService {
  public alert = new BehaviorSubject(null);

  constructor() { }

  showAlert(data) {
    this.alert.next(data);
  }

  showPToast(service: MessageService, alertData: AlertData, severity: 'success' | 'warn' | 'error' = 'success') {
    service.clear();
    service.add({
      severity,
      summary: alertData.summary,
      detail: alertData.detail,
      sticky: alertData.sticky,
      key: "store-logo",
      life: 7000,
    });
  }
}
